import React from "react";

export const SignOutIcon = () => {
  return (
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.21403 22.0009C2.89385 22.0055 2.57614 21.9444 2.28049 21.8214C1.98484 21.6984 1.71752 21.5162 1.49502 21.2859C1.2647 21.0635 1.08243 20.7961 0.959456 20.5005C0.83648 20.2048 0.775415 19.8871 0.780028 19.5669V14.6979H3.21403V19.5669H20.255V2.52593H3.21403V7.39495H0.780028V2.52593C0.775534 2.20576 0.836655 1.8881 0.959624 1.59246C1.08259 1.29681 1.2648 1.02947 1.49502 0.806933C1.71756 0.576708 1.98489 0.394501 2.28053 0.271532C2.57617 0.148563 2.89386 0.0874112 3.21403 0.0919057H20.255C20.5752 0.0874112 20.8929 0.148563 21.1885 0.271532C21.4842 0.394501 21.7515 0.576708 21.974 0.806933C22.2043 1.02947 22.3865 1.29681 22.5094 1.59246C22.6324 1.8881 22.6935 2.20576 22.689 2.52593V19.5669C22.6936 19.8871 22.6326 20.2048 22.5096 20.5005C22.3866 20.7961 22.2043 21.0635 21.974 21.2859C21.7515 21.5162 21.4842 21.6984 21.1886 21.8214C20.8929 21.9444 20.5752 22.0055 20.255 22.0009H3.21403ZM9.90903 17.1319L8.20903 15.3669L11.309 12.267H0.780028V9.83196H11.309L8.20903 6.73192L9.90903 4.96691L15.995 11.0529L9.90903 17.1319Z"
        fill="#333333"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const PLusIcon = () =>{
  return(
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 15V8M8 8V1M8 8H1M8 8H15" stroke="#2F3A79" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export const MinusIcon = () =>{
  return(
    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-q7mezt" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="RemoveOutlinedIcon"><path d="M19 13H5v-2h14z"></path></svg>
  )
}
export const RemoveIcon = () =>{
  return(
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.05025 10.9498L6 6.00008M6 6.00008L10.9497 1.05033M6 6.00008L1.05025 1.05033M6 6.00008L10.9497 10.9498" stroke="#2F3A79" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export const NavigatorIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1410_7821)">
        <path
          d="M5.72727 2.86364C5.72727 1.28209 4.44518 0 2.86364 0C1.28209 0 0 1.28209 0 2.86364C0 4.44518 1.28209 5.72727 2.86364 5.72727C4.44518 5.72727 5.72727 4.44518 5.72727 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 2.86364C15.4546 1.28209 14.1725 0 12.5909 0C11.0094 0 9.72729 1.28209 9.72729 2.86364C9.72729 4.44518 11.0094 5.72727 12.5909 5.72727C14.1725 5.72727 15.4546 4.44518 15.4546 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 2.86364C25.1818 1.28209 23.8997 0 22.3182 0C20.7366 0 19.4545 1.28209 19.4545 2.86364C19.4545 4.44518 20.7366 5.72727 22.3182 5.72727C23.8997 5.72727 25.1818 4.44518 25.1818 2.86364Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 12.5909C5.72727 11.0094 4.44518 9.72726 2.86364 9.72726C1.28209 9.72726 0 11.0094 0 12.5909C0 14.1724 1.28209 15.4545 2.86364 15.4545C4.44518 15.4545 5.72727 14.1724 5.72727 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 12.5909C15.4546 11.0094 14.1725 9.72726 12.5909 9.72726C11.0094 9.72726 9.72729 11.0094 9.72729 12.5909C9.72729 14.1724 11.0094 15.4545 12.5909 15.4545C14.1725 15.4545 15.4546 14.1724 15.4546 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 12.5909C25.1818 11.0094 23.8997 9.72726 22.3182 9.72726C20.7366 9.72726 19.4545 11.0094 19.4545 12.5909C19.4545 14.1724 20.7366 15.4545 22.3182 15.4545C23.8997 15.4545 25.1818 14.1724 25.1818 12.5909Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M5.72727 22.3182C5.72727 20.7366 4.44518 19.4545 2.86364 19.4545C1.28209 19.4545 0 20.7366 0 22.3182C0 23.8997 1.28209 25.1818 2.86364 25.1818C4.44518 25.1818 5.72727 23.8997 5.72727 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M15.4546 22.3182C15.4546 20.7366 14.1725 19.4545 12.5909 19.4545C11.0094 19.4545 9.72729 20.7366 9.72729 22.3182C9.72729 23.8997 11.0094 25.1818 12.5909 25.1818C14.1725 25.1818 15.4546 23.8997 15.4546 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
        <path
          d="M25.1818 22.3182C25.1818 20.7366 23.8997 19.4545 22.3182 19.4545C20.7366 19.4545 19.4545 20.7366 19.4545 22.3182C19.4545 23.8997 20.7366 25.1818 22.3182 25.1818C23.8997 25.1818 25.1818 23.8997 25.1818 22.3182Z"
          fill="#2F3A79"
          fill-opacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1410_7821">
          <rect width="26" height="25.1818" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BackIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35833 1C4.60935 2.29326 3.03515 3.80752 1.675 5.505C1.56182 5.64516 1.50006 5.81985 1.5 6M1.5 6C1.50006 6.18015 1.56182 6.35484 1.675 6.49499C3.03515 8.19248 4.60935 9.70674 6.35833 11M1.5 6H16.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const BreadcrumbIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="#2F3A79 "
    class="bi bi-caret-right-fill"
    viewBox="0 0 16 16"
  >
    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
  </svg>
);

export const Groups = () => {
  return (
    <svg width="30" height="27" viewBox="0 0 30 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 22.5C17.5 21.9477 17.9477 21.5 18.5 21.5C19.0523 21.5 19.5 21.9477 19.5 22.5C19.5 23.0523 19.0523 23.5 18.5 23.5C17.9477 23.5 17.5 23.0523 17.5 22.5Z"
        fill="black"
      />
      <path
        d="M14.5 17C14.5 16.4477 14.9477 16 15.5 16C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18C14.9477 18 14.5 17.5523 14.5 17Z"
        fill="black"
      />
      <path
        d="M24 15.5C24 14.9477 24.4477 14.5 25 14.5C25.5523 14.5 26 14.9477 26 15.5C26 16.0523 25.5523 16.5 25 16.5C24.4477 16.5 24 16.0523 24 15.5Z"
        fill="black"
      />
      <path
        d="M14.5 12C14.5 11.4477 14.9477 11 15.5 11C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13C14.9477 13 14.5 12.5523 14.5 12Z"
        fill="black"
      />
      <path
        d="M11.5 6.5V2C11.5 1.44772 11.0523 1 10.5 1H6.25M11.5 6.5H24C24.5523 6.5 25 6.94772 25 7.5V15.5M11.5 6.5V12M11.5 6.5H6.25M6.25 1H2C1.44772 1 1 1.44772 1 2V6.5M6.25 1V6.5M6.25 22.5H2C1.44772 22.5 1 22.0523 1 21.5V17M6.25 22.5H11.5M6.25 22.5V17M11.5 22.5V17M11.5 22.5H18.5M1 17H6.25M1 17V12M6.25 17H11.5M6.25 17V12M11.5 17V12M11.5 17H15.5M1 12H6.25M1 12V6.5M6.25 12H11.5M6.25 12V6.5M11.5 12H15.5M6.25 6.5H1"
        stroke="black"
        stroke-width="2"
      />
      <path
        d="M19 16.5C19 16.2239 19.2239 16 19.5 16H20.5C20.7761 16 21 16.2239 21 16.5V17.5C21 17.7761 20.7761 18 20.5 18H19.5C19.2239 18 19 17.7761 19 17.5V16.5Z"
        fill="black"
      />
      <path
        d="M19 11.5C19 11.2239 19.2239 11 19.5 11H20.5C20.7761 11 21 11.2239 21 11.5V12.5C21 12.7761 20.7761 13 20.5 13H19.5C19.2239 13 19 12.7761 19 12.5V11.5Z"
        fill="black"
      />
      <path
        d="M24.8333 25.6667V21.8333M24.8333 21.8333V18M24.8333 21.8333H21M24.8333 21.8333H28.6667"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Users = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2222 16.3333H6.11111C4.75556 16.3333 3.45553 16.8718 2.49701 17.8303C1.53849 18.7889 1 20.0889 1 21.4444C1 22.1222 1.26924 22.7722 1.7485 23.2515C2.22776 23.7308 2.87778 24 3.55556 24H16.3333M20.1667 20.1667V16.3333M20.1667 16.3333V12.5M20.1667 16.3333H16.3333M20.1667 16.3333H24M16.3333 6.11111C16.3333 7.46666 15.7948 8.7667 14.8363 9.72522C13.8778 10.6837 12.5778 11.2222 11.2222 11.2222C9.86667 11.2222 8.56664 10.6837 7.60812 9.72522C6.6496 8.7667 6.11111 7.46666 6.11111 6.11111C6.11111 4.75556 6.6496 3.45553 7.60812 2.49701C8.56664 1.53849 9.86667 1 11.2222 1C12.5778 1 13.8778 1.53849 14.8363 2.49701C15.7948 3.45553 16.3333 4.75556 16.3333 6.11111Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DashboardIcon = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5.2666C1 3.77327 1 3.02678 1.29067 2.45345C1.54667 1.96012 1.95466 1.54663 2.45599 1.29329C3.02666 0.999961 3.77333 1 5.26666 1H6.06667C7.56 1 8.30667 0.999961 8.87734 1.29329C9.37867 1.54663 9.78666 1.96012 10.0427 2.45345C10.3333 3.02678 10.3333 3.77327 10.3333 5.2666V6.06673C10.3333 7.56007 10.3333 8.30655 10.0427 8.87988C9.78666 9.37322 9.37867 9.78671 8.87734 10.04C8.30667 10.3334 7.56 10.3333 6.06667 10.3333H5.26666C3.77333 10.3333 3.02666 10.3334 2.45599 10.04C1.95466 9.78671 1.54667 9.37322 1.29067 8.87988C1 8.30655 1 7.56007 1 6.06673V5.2666ZM1 19.9333C1 18.4399 1 17.6935 1.29067 17.1201C1.54667 16.6268 1.95466 16.2133 2.45599 15.96C3.02666 15.6666 3.77333 15.6667 5.26666 15.6667H6.06667C7.56 15.6667 8.30667 15.6666 8.87734 15.96C9.37867 16.2133 9.78666 16.6268 10.0427 17.1201C10.3333 17.6935 10.3333 18.4399 10.3333 19.9333V20.7334C10.3333 22.2267 10.3333 22.9732 10.0427 23.5466C9.78666 24.0399 9.37867 24.4534 8.87734 24.7067C8.30667 25 7.56 25 6.06667 25H5.26666C3.77333 25 3.02666 25 2.45599 24.7067C1.95466 24.4534 1.54667 24.0399 1.29067 23.5466C1 22.9732 1 22.2267 1 20.7334V19.9333ZM15.6667 5.2666C15.6667 3.77327 15.6667 3.02678 15.9573 2.45345C16.2133 1.96012 16.6213 1.54663 17.1227 1.29329C17.6933 0.999961 18.44 1 19.9333 1H20.7333C22.2267 1 22.9733 0.999961 23.544 1.29329C24.0453 1.54663 24.4533 1.96012 24.7093 2.45345C25 3.02678 25 3.77327 25 5.2666V6.06673C25 7.56007 25 8.30655 24.7093 8.87988C24.4533 9.37322 24.0453 9.78671 23.544 10.04C22.9733 10.3334 22.2267 10.3333 20.7333 10.3333H19.9333C18.44 10.3333 17.6933 10.3334 17.1227 10.04C16.6213 9.78671 16.2133 9.37322 15.9573 8.87988C15.6667 8.30655 15.6667 7.56007 15.6667 6.06673V5.2666ZM15.6667 19.9333C15.6667 18.4399 15.6667 17.6935 15.9573 17.1201C16.2133 16.6268 16.6213 16.2133 17.1227 15.96C17.6933 15.6666 18.44 15.6667 19.9333 15.6667H20.7333C22.2267 15.6667 22.9733 15.6666 23.544 15.96C24.0453 16.2133 24.4533 16.6268 24.7093 17.1201C25 17.6935 25 18.4399 25 19.9333V20.7334C25 22.2267 25 22.9732 24.7093 23.5466C24.4533 24.0399 24.0453 24.4534 23.544 24.7067C22.9733 25 22.2267 25 20.7333 25H19.9333C18.44 25 17.6933 25 17.1227 24.7067C16.6213 24.4534 16.2133 24.0399 15.9573 23.5466C15.6667 22.9732 15.6667 22.2267 15.6667 20.7334V19.9333Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ResourceIcon = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 12.9985V25M12.5 12.9985L1.43444 7.17457M12.5 12.9985L18.0328 10.0801M12.5 25C12.7773 25 13.0558 24.9748 13.328 24.9116C13.9452 24.7979 14.5266 24.4693 15.6868 23.8377L20.8132 21.0332C21.9734 20.4015 22.5548 20.0857 22.9765 19.6435C23.3509 19.2393 23.632 18.7845 23.8045 18.2792C24 17.7107 24 17.0789 24 15.803V10.1939C24 8.91797 24 8.2862 23.8045 7.71771C23.7406 7.52821 23.6601 7.35143 23.5656 7.17457M12.5 25C12.2227 25 11.9442 24.9748 11.672 24.9116C11.0548 24.7979 10.4734 24.4693 9.31322 23.8377L4.18678 21.0332C3.02656 20.4015 2.44517 20.0857 2.0235 19.6435C1.65377 19.2512 1.37165 18.7864 1.1955 18.2792C1 17.7107 1 17.0789 1 15.803V10.1939C1 8.91797 1 8.2862 1.1955 7.71771C1.25939 7.52821 1.33988 7.35143 1.43444 7.17457M1.43444 7.17457C1.59161 6.88401 1.78967 6.60604 2.0235 6.35338C2.44517 5.91122 3.02656 5.59542 4.18678 4.96376L6.75 3.56149M18.0328 10.0801L23.5656 7.17457M18.0328 10.0801L6.75 3.56149M18.0328 10.0801V14.666M23.5656 7.17457C23.4045 6.87769 23.2066 6.60181 22.9765 6.35338C22.5548 5.91122 21.9734 5.59542 20.8132 4.96376L15.6868 2.15922C14.5266 1.52756 13.9452 1.19898 13.328 1.08528C12.782 0.971574 12.218 0.971574 11.672 1.08528C11.0548 1.19898 10.4734 1.52756 9.31322 2.15922L6.75 3.56149"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RedirectIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.9999 12.8749C20.9999 14.6124 20.9999 15.4875 20.8274 16.2125C20.5582 17.3327 19.9843 18.3564 19.1691 19.1705C18.3539 19.9846 17.3292 20.5572 16.2087 20.8248C15.4899 20.9998 14.6187 20.9999 12.8749 20.9999H10.9999C7.49996 20.9999 5.74996 20.9998 4.41247 20.3248C3.23633 19.7229 2.28043 18.7649 1.68124 17.5874C0.999998 16.2499 1 14.4999 1 10.9999V10.3749C1 7.46246 0.999996 6.01242 1.47624 4.86243C1.78949 4.10304 2.24951 3.41294 2.82994 2.83165C3.41036 2.25037 4.09981 1.78937 4.85873 1.475C5.82872 1.07501 7.01996 1.0125 9.12494 1M20.6999 7.81239C21.0274 5.77491 21.0874 3.71253 20.8774 1.67504C20.8633 1.53329 20.8006 1.40071 20.6999 1.29999M20.6999 1.29999C20.5998 1.19802 20.4661 1.13582 20.3236 1.12497C18.2773 0.914588 16.2122 0.973441 14.1812 1.29999M20.6999 1.29999L8.49995 13.4999"
        stroke="#BEBEBE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";

export const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.38916 13.8916C6.50472 13.8916 5.67106 13.7223 4.88818 13.3838C4.10954 13.0452 3.42188 12.5776 2.8252 11.981C2.22852 11.3843 1.7609 10.6966 1.42236 9.91797C1.08382 9.13509 0.914551 8.30143 0.914551 7.41699C0.914551 6.53255 1.08382 5.70101 1.42236 4.92236C1.7609 4.13949 2.2264 3.44971 2.81885 2.85303C3.41553 2.25635 4.10319 1.78874 4.88184 1.4502C5.66471 1.11165 6.49837 0.942383 7.38281 0.942383C8.26725 0.942383 9.10091 1.11165 9.88379 1.4502C10.6667 1.78874 11.3564 2.25635 11.9531 2.85303C12.5498 3.44971 13.0174 4.13949 13.356 4.92236C13.6945 5.70101 13.8638 6.53255 13.8638 7.41699C13.8638 8.30143 13.6945 9.13509 13.356 9.91797C13.0174 10.6966 12.5498 11.3843 11.9531 11.981C11.3564 12.5776 10.6667 13.0452 9.88379 13.3838C9.10514 13.7223 8.2736 13.8916 7.38916 13.8916ZM7.38916 12.8125C8.13818 12.8125 8.83854 12.6729 9.49023 12.3936C10.1462 12.1143 10.7196 11.7292 11.2104 11.2383C11.7056 10.7432 12.0907 10.1698 12.3657 9.51807C12.645 8.86637 12.7847 8.16602 12.7847 7.41699C12.7847 6.66797 12.645 5.96761 12.3657 5.31592C12.0864 4.66423 11.6992 4.09082 11.2041 3.5957C10.709 3.10059 10.1356 2.71549 9.48389 2.44043C8.83219 2.16113 8.13184 2.02148 7.38281 2.02148C6.63379 2.02148 5.93343 2.16113 5.28174 2.44043C4.63005 2.71549 4.05876 3.10059 3.56787 3.5957C3.07699 4.09082 2.69189 4.66423 2.4126 5.31592C2.13753 5.96761 2 6.66797 2 7.41699C2 8.16602 2.13753 8.86637 2.4126 9.51807C2.69189 10.1698 3.07699 10.7432 3.56787 11.2383C4.06299 11.7292 4.63639 12.1143 5.28809 12.3936C5.93978 12.6729 6.64014 12.8125 7.38916 12.8125ZM6.27832 10.9082C6.14714 10.9082 6.03711 10.8659 5.94824 10.7812C5.85938 10.6966 5.81494 10.5908 5.81494 10.4639C5.81494 10.3369 5.85938 10.2311 5.94824 10.1465C6.03711 10.0618 6.14714 10.0195 6.27832 10.0195H7.06543V7.10596H6.38623C6.25505 7.10596 6.14502 7.06364 6.05615 6.979C5.96729 6.89437 5.92285 6.78857 5.92285 6.66162C5.92285 6.53467 5.96729 6.42887 6.05615 6.34424C6.14502 6.2596 6.25505 6.21729 6.38623 6.21729H7.57959C7.7404 6.21729 7.86312 6.27018 7.94775 6.37598C8.03239 6.47754 8.07471 6.61507 8.07471 6.78857V10.0195H8.86182C8.993 10.0195 9.10303 10.0618 9.19189 10.1465C9.28076 10.2311 9.3252 10.3369 9.3252 10.4639C9.3252 10.5908 9.28076 10.6966 9.19189 10.7812C9.10303 10.8659 8.993 10.9082 8.86182 10.9082H6.27832ZM7.33203 5.15723C7.10352 5.15723 6.90885 5.07682 6.74805 4.91602C6.58724 4.75521 6.50684 4.56055 6.50684 4.33203C6.50684 4.09928 6.58724 3.90251 6.74805 3.7417C6.90885 3.58089 7.10352 3.50049 7.33203 3.50049C7.56478 3.50049 7.75944 3.58089 7.91602 3.7417C8.07682 3.90251 8.15723 4.09928 8.15723 4.33203C8.15723 4.56055 8.07682 4.75521 7.91602 4.91602C7.75944 5.07682 7.56478 5.15723 7.33203 5.15723Z"
      fill="black"
      fill-opacity="0.5"
    />
  </svg>
);
